<template>
  <el-dialog title="提示" :close-on-click-modal="false" v-model="drawer" append-to-body width="676px" @close="close">
    <el-scrollbar>
      <div class="add-menu">
        <div class="add-menu-option">
          <span class="title">名称</span>
          <div class="content">
            <el-input v-model="info.label" placeholder="请输入名称"></el-input>
            <el-popover class="font-set" v-model:visible="isPop" popper-class="font-set-pop" placement="bottom" width="218" trigger="click">
              <template #reference>
                <i class="iconfont icon-shezhi21"></i>
              </template>
              <logoEdit class="title-logo-edit" @change-all-font="changeFont" :columnFont="info.fontStyle || fontnomol" colorPosition="top"
                @close="isPop = false" />
            </el-popover>
          </div>
        </div>
      </div>
    </el-scrollbar>
    <div class="add-menu-footer">
      <el-button @click="close" size="mini">取 消</el-button>
      <el-button type="primary" @click="confirm" size="mini">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
const fontnomol = {
  fontSize: '14px',
  fontWeight: 'normal', // 是否加粗
  fontStyle: 'normal', // 是否斜体
  textDecoration: 'none', // 是否下划线
  // lineHeight: "12px", //选择的行高
  color: '#333', // 选择的颜色
  textAlign: 'center', // 文字位置排版
  justifyContent: 'flex-center',//文字板块位置排版
}
import { cloneDeep } from 'lodash';
import logoEdit from '@/components/common/logoEdit.vue'
export default {
  name: 'titleSet',
  components: {
    logoEdit
  },
  props: {
  },
  data() {
    return {
      drawer: false,
      info: {},
      isPop: false,
      fontnomol
    }
  },
  methods: {
    changeFont(val) {
      this.info.fontStyle = cloneDeep(val)
    },
    close() { 
      this.drawer = false
      this.info = {}
      this.isPop = false
    },
    open(config) {
      if (config) {
        this.info = cloneDeep(config)
      }
      this.drawer = true
    },
    confirm() {
      this.drawer = false
      this.$emit('confirm', this.info)
    },
  }
}
</script>
<style scoped lang="scss">
::v-deep .el-scrollbar {
  overflow: hidden;
  height: 100%;

  .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  .el-scrollbar__view {
    height: 100%;
  }
}

::v-deep.title-logo-edit {
  box-shadow: none;
  margin: -12px;
  .el-form {
    .el-form-item {
      display: flex;

      .el-form-item__content {
        flex: 1;

        .el-select {
          .el-input__suffix {
            .el-input__icon {
              line-height: 36px;
            }
          }
        }
      }

      .el-form-item__label {
        width: 40px;
        font-size: 14px;
        font-weight: 400;
        color: #304265;
        margin-right: 10px;
        text-align: left;
      }
    }
  }
}

::v-deep .el-dialog {
  border-radius: 4px;

  .el-dialog__header {
    padding: 15px 20px;
    border-bottom: 1px solid #d8d8d8;

    .el-dialog__title {
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 26px;
      color: #33393e;
    }

    .el-dialog__headerbtn {
      right: 15px;
      top: 12px;
      font-size: 20px;
      color: #bfbfbf;
    }
  }

  .el-dialog__body {
    padding: 15px 0 15px 15px;
    max-height: 636px;
    box-sizing: border-box;
  }
}

.add-menu-footer {
  text-align: right;
  padding: 0 15px 15px 0;
  margin-left: -15px;
  width: 100%;
  background: #fff;

  ::v-deep .el-button {
    width: 70px;
    height: 35px;
    padding: 0;
  }
}

.add-menu {
  .flex-c {
    flex-direction: column;
  }

  &-option {
    display: flex;
    align-items: center;
    padding-bottom: 11px;
    margin-bottom: 10px;

    .title {
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #33393e;
      margin-right: 10px;
    }

    .content {
      flex: 1;
      display: flex;
      align-items: center;

      .icon-shezhi21 {
        font-size: 18px;
        color: #4e86ff;
        margin-left: 10px;
        cursor: pointer;
      }
    }
    ::v-deep .el-input {
      line-height: 32px;
      width: 174px;
      height: 32px;
      .el-input__inner {
        width: 100%;
        height: 32px;
        line-height: 32px;
        padding: 0 8px;
      }
    }
  }
}

::v-deep.tab-color-custom {
  display: flex;
  margin-left: 20px;
  height: 100%;

  .custom-title {
    font-size: 12px;
    font-weight: 400;
    color: rgba(153, 163, 173, 1);
  }

  .custom-color {
    margin-left: 4px;
  }
}

::v-deep .custom-color .el-color-picker {
  border-radius: 100%;
  width: 16px;
  height: 16px;
  cursor: pointer;
  background: rgba(153, 153, 153, 0.31);
  transition: 0.3s;
  box-shadow: 0px 0px 3px 0px rgba(153, 153, 153, 0.31);

  .el-color-picker__trigger {
    width: 18px;
    height: 12px;
    padding: 0;
    border: none;

    .el-color-picker__color {
      display: none;
    }

    .el-color-picker__icon {
      display: none !important;
    }
  }
}
</style>